<div class="case flex flex-col" [routerLink]="caseItem().link">
  <div class="case__name flex w-full justify-between">
    {{ caseItem().name }}
  </div>
  <div class="case__image flex justify-center w-full">
    <img
      [src]="caseItem().image"
      [alt]="'tf2hunt' + caseItem().name"
      loading="lazy"
      width="114px"
      height="77px"
      class="flex justify-center"
    />
  </div>

  <div class="case__details">
    <div class="w-full button h-32 rounded-4 button--style-white-04">View</div>
    <div class="w-full button h-32 rounded-4 button--style-primary">
      <app-balance-icon
        [balance]="balance()"
        color="var(--yellow)"
      ></app-balance-icon>
      {{ caseItem().price | number : "1.2-2" }}
    </div>
  </div>
</div>
